<template>
  <div id="im" class="im">
    <div
      class="im__left-column"
      :class="[{close: isClosedLeftColumn}]"
    >
      <div
        class="im__minimizer"
        :class="[{close: isClosedLeftColumn}]"
        @click="toggleLeftColumn"
      ></div>
      <div class="im__wrapper">
        <Search/>
        <Users/>
      </div>
    </div>
    <div
      v-if="dialog" class="im__right-column"
      :class="[{full: isClosedLeftColumn}]"
    >
      <Nav/>
      <Dialog/>
      <Form/>
    </div>
  </div>
</template>
<script>
  import Search from './components/search/Search.vue';
  import Users from './components/groups/Users.vue';
  import Nav from './components/nav/Nav.vue';
  import Dialog from './components/dialog/Dialog.vue';
  import Form from './components/form/Form.vue';

  export default {
    name: 'app',
    components: {
      Users,
      Search,
      Nav,
      Dialog,
      Form
    },
    props: {
      userTo: {
        type: String,
        default: ""
      },
      userAuthID: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        isClosedLeftColumn: false
      };
    },
    mounted() {
      this.$store.dispatch('setUserAuthID', this.userAuthID);
      this.$store.dispatch('restoreDialogs', {
        userTo: this.userTo
      });
      this.$store.dispatch('initTimers');

      document.addEventListener(
        'click',
        e => {
          this.documentClick(e);
        },
        false
      );
    },
    computed: {
      dialog() {
        return !!this.$store.state.dialog;
      }
    },
    methods: {
      toggleLeftColumn() {
        this.isClosedLeftColumn = !this.isClosedLeftColumn;
      },
      documentClick(e) {
        const itemMessage = e.target.closest('#letterbox .privat-message .item-message');
        if (itemMessage !== null) {
          const userID = itemMessage.closest('.item-container').getAttribute('from');
          this.$store.dispatch('openDialogByUserID', userID);
          e.preventDefault();
          return false;
        }
        const allCorrespond = e.target.closest('.nascent-container .all-correspond');
        if (allCorrespond !== null) {
          const userID = allCorrespond.closest('.nascent-container').getAttribute('from');
          this.$store.dispatch('openDialogByUserID', userID);
          e.preventDefault();
          return false;
        }
      }
    }
  };
</script>

<style lang="scss">
  .im {
    $root: &;

    display: flex;
    min-height: 100%;

    &__wrapper {
      padding: 14px;
      width: calc(100% - 20px);
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: auto;
      max-height: 894px;
    }

    &__left-column {
      display: flex;
      flex-shrink: 0;
      box-sizing: border-box;
      overflow: hidden;
      border-right: 1px solid #D6D6D6;
      width: 240px;

      &.close {
        width: 20px;

        .im__wrapper {
          display: none;
        }
      }

    }

    &__minimizer {
      display: block;
      box-sizing: border-box;
      border-right: 1px solid #D6D6D6;
      width: 20px;
      position: relative;
      cursor: pointer;

      &::after {
        display: block;
        content: "";
        margin: 0 -4px 0 0;
        border: 4px solid transparent;
        border-left-color: #8d96a1;
        width: 0;
        height: 0;
        position: absolute;
        top: 8px;
        left: 8px;
      }

      &:hover {
        &::after {
          border-left-color: #242A32;
        }
      }

      &.close {
        &::after {
          margin-left: -4px;
          border-color: transparent;
          border-right-color: #8d96a1;
        }
      }
      &.close:hover {
        &::after {
          border-right-color: #242A32;
        }
      }
    }

    &__right-column {
      display: flex;
      flex-direction: column;
      width: calc(100% - 240px);

      &.full {
        width: calc(100% - 20px);
      }
    }
  }
</style>